import { Box } from '@factorialco/deprecated-design-system'

import { CustomizationProps } from '../../withCustomizationFields'
import { PermissionsProps } from '../../withFieldPermissions'
import FromField from './FromField'
import ToField from './ToField'

interface Props extends PermissionsProps, CustomizationProps {
  loading: boolean
}

const Trip = (props: Props) => {
  return (
    <Box gap="s16">
      <FromField {...props} fieldIdentifier="from" isFieldMandatory />
      <ToField {...props} fieldIdentifier="to" isFieldMandatory />
    </Box>
  )
}

export default Trip
